import Vue from "vue";

import SearchBox from "./SearchBox.vue";

export function load() {
    const selector = "searchbox";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(SearchBox, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
